export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const PHONE_REGEX =
  /^\+?(\d{1,4})?[-.\s]?(\(?\d{1,4}\)?)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/

/** Backend format: `@[User Name](<userId>)` */
export const BACKEND_MENTION_PATTERN_REG = /@\[([^\]]*)\]\(([^)]*)\)/g
